<div class="dataview" *ngIf="initialized ">

  <div class="datex-report full-size-report-container">
    <gc-activereports-viewer *ngIf="report"
                         #reportViewer
                         (init)="onViewerInit()"></gc-activereports-viewer>
  </div>
</div>

